exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/* CSS Document */\n/*メインコンテンツ系*/\n/*tooltip font*/\n/*ステータスカラー*/\n/* Sass Document */\n/* Filetype Web Font **********************************************************/\n#tab1-item.layout-contents {\n  padding-bottom: 68px; }\n.scroll-y {\n  height: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n.layout-uploader {\n  padding-bottom: 68px; }\n.layout-uploader .layout-uploader_dropzone {\n    padding-bottom: 30px;\n    max-height: calc(100% - 68px - 78px); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3922/wa3922.component.scss
// module id = ../../../../../src/app/pages/wa3Shipment/wa3922/wa3922.component.scss
// module chunks = main